jQuery(function($) {
  new MenuSeparators('.categories .category', 1, '-')

  let taxonomyId = 'all'
  
  $('.category').on('click', function() {
    if (taxonomyId != $(this).attr('data-taxonomy-id')) {
      taxonomyId = $(this).attr('data-taxonomy-id')

      $('.category.active').removeClass('active')
      $(this).addClass('active')

      filterOffers(taxonomyId)
    }
  })

  function filterOffers(taxonomyId) {
    const data = new FormData();
    data.append('action', 'filter_offers');
    data.append('taxonomy_id', taxonomyId);

    fetch(wp_vars.ajaxurl, {
      method: 'POST',
      credentials: 'same-origin',
      body: data
    })
    .then(response => response.text())
    .then(html => {
      $('.offers_container').html(html);
      ScrollTrigger.refresh()
    });
  }
})